module.exports = "<div class=\"angular-notifications-container\">\n  <div class=\"angular-notifications-icon overlay\" *ngIf=\"visible\">\n    <div *ngIf=\"hideCount\">{{count}}</div>\n  </div>\n  <div class=\"notification-inner\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/components/notification-icon/notification-icon.component.html
// module id = ./src/app/core.module/components/notification-icon/notification-icon.component.html
// module chunks = main